import { createContext, useContext } from 'react'

/**
 * Per-slot context providing whether the enclosing TabSlot is the active tab.
 *
 * Replaces the previous `isActive` prop that flowed through `TabContent` into
 * every page component. Prop-drilling forced `React.memo(TabContent)` to
 * re-render on every tab switch — including for inactive slots — which
 * cascaded through the page's entire subtree (TaskBoard → DndContext →
 * SortableContext → TaskList, etc.).
 *
 * With a context, only components that explicitly call `useIsActiveTab()`
 * re-subscribe. The rest of the page subtree memoizes as usual.
 */
const ActiveTabContext = createContext<boolean>(true)

export const ActiveTabProvider = ActiveTabContext.Provider

export function useIsActiveTab(): boolean {
  return useContext(ActiveTabContext)
}

/**
 * Die Kennung des Tabs, in dessen Slot dieser Teilbaum steckt.
 *
 * Nötig, seit `CanvasFocusContext` den Canvas-Modus PRO TAB hält: Panel und
 * Seite müssen sagen können, um WESSEN Canvas es geht. `useIsActiveTab()` sagt
 * nur, ob der Slot gerade vorn ist, und der aktive Tab aus dem `TabManager` ist
 * beim inaktiven Slot der falsche.
 *
 * Leerer Vorgabewert für Seiten außerhalb des TabStacks (Einstellungsfenster,
 * Storybook) — dort gibt es keinen Slot, dem etwas gehören könnte.
 */
const TabIdContext = createContext<string>('')

export const TabIdProvider = TabIdContext.Provider

export function useTabId(): string {
  return useContext(TabIdContext)
}
